import React from 'react';
import Icon from '../../../components/AppIcon';

const TimeSlotGrid = ({ 
  availableTimeSlots, 
  selectedTime, 
  setSelectedTime, 
  loadingAvailableTimeSlots,
  validationErrors,
  psychologist 
}) => {

  const handleTimeSelect = (slot) => {
    // FIX: Use slot.value instead of slot.startTime
    if (slot?.value) {
      setSelectedTime(slot?.value);
    }
  };

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Clock" size={20} color="var(--color-primary)" />
        Horários disponíveis
      </h3>
      {validationErrors?.selectedTime && (
        <p className="text-sm text-destructive mb-3 flex items-center gap-1">
          <Icon name="AlertCircle" size={14} color="var(--color-destructive)" />
          {validationErrors?.selectedTime}
        </p>
      )}
      {loadingAvailableTimeSlots ? (
        <div className="text-center py-12">
          <Icon 
            name="Loader" 
            size={40} 
            color="var(--color-primary)" 
            className="animate-spin mx-auto mb-4" 
          />
          <p className="text-muted-foreground">Carregando horários disponíveis...</p>
        </div>
      ) : availableTimeSlots?.length > 0 ? (
        <>
          <div className="grid grid-cols-4 gap-3 mb-4">
            {availableTimeSlots
            ?.filter(slot => !slot.isBlocked) 
            ?.map((slot, index) => (
              <button
                key={slot.id}
                type="button"
                onClick={() => handleTimeSelect(slot)}
                className={`p-4 rounded-lg text-center font-medium transition-all ${
                  selectedTime === slot?.value
                    ? 'bg-primary text-primary-foreground shadow-md scale-105'
                    : 'bg-muted hover:bg-muted/80 text-foreground hover:scale-105'
                }`}
              >
                {/* FIX: Display slot.label instead of slot.startTime */}
                {slot?.label}
              </button>
            ))}
          </div>

          {selectedTime && (
            <div className="bg-success/10 border border-success/20 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="Check" size={20} color="var(--color-success)" />
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-foreground mb-2">
                    Horário selecionado
                  </h4>
                  <p className="text-muted-foreground">
                    {selectedTime}
                  </p>
                  {psychologist?.consultation_price && (
                    <p className="text-muted-foreground text-sm mt-1">
                      Valor: {psychologist?.currency === 'BRL' ? 'R$' : '$'} {psychologist?.consultation_price}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-12 bg-muted/50 rounded-lg">
          <Icon
            name="CalendarX"
            size={48}
            color="var(--color-muted-foreground)"
            className="mx-auto mb-4 opacity-50"
          />
          <p className="text-muted-foreground text-lg font-medium mb-2">
            Nenhum horário disponível
          </p>
          <p className="text-muted-foreground text-sm">
            Tente selecionar outra data
          </p>
        </div>
      )}
    </div>
  );
};

export default TimeSlotGrid;




